import { render, staticRenderFns } from "./qPaginate.vue?vue&type=template&id=2db44c78&scoped=true&"
import script from "./qPaginate.vue?vue&type=script&lang=ts&"
export * from "./qPaginate.vue?vue&type=script&lang=ts&"
import style0 from "./qPaginate.vue?vue&type=style&index=0&id=2db44c78&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db44c78",
  null
  
)

export default component.exports